import { Icon } from 'antd-mobile';
import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData, convertStyleData } from '@utils/tools';

import OfficialPage from '../OfficialPage';
import { TopNav } from '@common/top-nav/TopNav';
import './ExchangeCouponDetail.less';

export default class ExchangeCouponDetail extends OfficialPage {
  state = {
    couponId: '', // receive时为商家设置优惠券id，use时为用户领取优惠券id
    couponDetail: {},
    receiveSuccess: 0, // 领取成功弹窗是否显示
    receiveCount: 0, // 已领取数量
    receiveLimitNum: 0, // 领取限制数量
    rechargeSuccess: 0, // 充值成功弹窗是否显示
    verifySuccess: false,
    verifyQrcodeUrl: '',
    verifyShow: false,
    style: {},
    verifyData: {
      success: false,
      qrcodeUrl: ''
    }
  }
  cutStyle = str => {
    if (typeof str !== 'string') {
      return str;
    }
    // 截取style样式
    let obj = str.split(';').reduce((p, e) => {
      let [k, v] = e.split(':')
      v = (v && v.trim()) || ''
      if (v) {
        p[k] = v
      }
      return p
    }, {})
    return obj
  }

  constructor(props) {
    super(props);
    document.title = '兑换券详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let that = this
    let exchangeCouponDetail = app.globalData.exchangeCouponStyle
    let style = {}
    if (exchangeCouponDetail) {
      let styleArr = this.cutStyle(exchangeCouponDetail.style)
      style.strStyle = styleArr
      style.lineBackgroundColor =
        exchangeCouponDetail.customFeature.lineBackgroundColor
      style.secColor = exchangeCouponDetail.customFeature.secColor
    }
    let id = options.id
    that.setData({
      couponId: id,
      style: style
    })
    app.sendRequest({
      url: '/index.php?r=AppShop/GetCouponInfo',
      data: {
        app_id: app.globalData.appId,
        coupon_id: id
      },
      hideLoading: true,
      success: function (res) {
        that.setCouponData(res.data)
      }
    })
  }

  setCouponData = data => {
    let that = this
    let useCondition = ''
    let stampsType,
      stampsUser = ''
    if (data.type == 0) {
      useCondition = '满' + data.condition + '，减' + data.value + '元'
      stampsType = '满减券'
    } else if (data.type == 1) {
      useCondition = '打' + data.value + '折'
      stampsType = '打折券'
    } else if (data.type == 2) {
      useCondition = '可抵扣' + data.value + '元'
      stampsType = '代金券'
    } else if (data.type == 3) {
      if (data.extra_condition == '') {
        useCondition = '直接兑换' + data.coupon_goods_info.title
      } else if (data.extra_condition.price) {
        useCondition =
          '消费满' +
          data.extra_condition.price +
          '元可兑换' +
          data.coupon_goods_info.title
      } else if (data.extra_condition.goods_id) {
        useCondition =
          '购买' +
          data.condition_goods_info.title +
          '可兑换' +
          data.coupon_goods_info.title
      }
      stampsType = '兑换券'
    } else if (data.type == 4) {
      useCondition = '储值金可充值' + data.value + '元'
      stampsType = '储值券'
    } else if (data.type == 5) {
      useCondition = data.extra_condition
      stampsType = '通用券'
    } else if (data.type == 6) {
      useCondition = '可使用' + parseInt(data.value) + '次'
      stampsType = '次数券'
    }
    let newData = data
    if (data.user_condition_list && data.user_condition_list.length > 0) {
      data.user_condition_list.forEach((res, i) => {
        if (i == data.user_condition_list.length - 1) {
          stampsUser = stampsUser + res
        } else {
          stampsUser = stampsUser + res + ','
        }
      })
    } else {
      if (data.user_condition == '0') {
        stampsUser = '所有用户'
      }
      if (data.user_condition == '1') {
        stampsUser = '所有会员'
      }
    }
    newData['useCondition'] = useCondition
    newData['stampsType'] = stampsType
    newData['stampsUser'] = stampsUser
    that.setData({
      couponDetail: newData
    })
  }
  formSubmit = event => {
    let that = this
    let couponDetail = that.data.couponDetail
    if (couponDetail.recv_status == 0) {
      app.showModal({ content: '超过可兑换次数' })
      return
    }
    if (couponDetail.exchange_condition.price !== 0) {
      app.turnToPage(
        '/exchangeCoupon/pages/exchangeCouponDetailOrder/exchangeCouponDetailOrder?id=' +
        couponDetail.id
      )
      return
    }
    app.showModal({
      title: '是否确认兑换？',
      content: '注：兑换成功后不支持退换',
      showCancel: true,
      cancelText: '否',
      confirmText: '是',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=appCoupon/addCouponOrder',
          data: {
            app_id: app.globalData.appId,
            id: couponDetail.id
          },
          hideLoading: true,
          success: function (res) {
            if (res.status !== 0) {
              return
            }
            if (couponDetail.limit_num >= couponDetail.user_recv_num + 1) {
              let newData = couponDetail
              newData.user_recv_num++
              that.setData({
                receiveSuccess: 1,
                couponDetail: newData
              })
            } else {
              let newData = couponDetail
              newData.recv_status = 0
              that.setData({
                receiveSuccess: 1,
                couponDetail: newData
              })
            }
            setTimeout(function () {
              that.hideReceiveToast()
            }, 3000)
          },
          complete: function (res) { }
        })
      }
    })
  }
  hideReceiveToast = () => {
    this.setData({
      receiveSuccess: 0
    })
  }
  hideRechargeToast = () => {
    this.setData({
      rechargeSuccess: 0
    })
  }
  timeInterval = ''
  socketOpen = false
  connectSocket = () => {
    var that = this
    app.connectSocket({
      url: 'wss://ceshi.zhichiwangluo.com', //线下test
      header: {
        'content-type': 'application/json'
      },
      method: 'GET'
    })
    app.onSocketOpen(function (res) {
      that.socketOpen = true
      let data = {
        action: 'mark_client',
        user_token: app.globalData.userInfo.user_token,
        scenario_name: 'app_coupon_verify',
        session_key: app.globalData.sessionKey
      }
      app.sendSocketMessage({
        data: JSON.stringify(data)
      })
      that.timeInterval = setInterval(function () {
        let data = {
          action: 'heartbeat',
          user_token: app.globalData.userInfo.user_token,
          scenario_name: 'app_coupon_verify',
          session_key: app.globalData.sessionKey
        }
        app.sendSocketMessage({
          data: JSON.stringify(data)
        })
      }, 30000)
    })
    app.onSocketMessage(function (res) {
      let data = JSON.parse(res.data)
      if (data.action == 'push_to_client') {
        let msg = JSON.parse(data.msg)
        if (msg.type == 'app_coupon_verify' && msg.status == 0) {
          that.setData({
            'verifyData.success': true,
            'couponDetail.status': 2
          })
          clearInterval(that.timeInterval)
          app.closeSocket()
        }
      }
    })
    app.onSocketClose(function (res) {
      that.socketOpen = false
      clearInterval(that.timeInterval)
      console.log('WebSocket 已关闭！')
    })
    app.onSocketError(function (res) {
      that.socketOpen = false
      console.log('WebSocket连接打开错误，请检查！')
    })
  }

  componentWillUnmount() {
    var that = this
    clearInterval(that.timeInterval)
    that.socketOpen && app.closeSocket()
  }

  render() {
    const { showGetUserInfo, couponDetail, style, receiveSuccess } = this.state
    return (
      <React.Fragment>
        <div className="official-page exchange-coupon-detail">
          <TopNav title="兑换券详情" />
          <div
            className="page"
            id="couponDetail"
            style={convertLineStyleData('background: ' + couponDetail.background)}
          >
            <div className="exchange-coupon-wrap show">
              <div className="exchange-coupon-bg">
                <div
                  className="ticket certificate-ticket"
                  onClick={this.gotoCouponDetail}
                  style={convertLineStyleData('background-color: ' + style.lineBackgroundColor)}
                >
                  <div
                    className="top-section"
                    style={convertLineStyleData('border-color:' + style.secColor)}
                  ></div>
                  {couponDetail.type == 0 ? (
                    <React.Fragment>
                      <div className="detail-info">
                        <div className="name">{couponDetail.title}</div>
                        {/*  <view class="use-condition">使用条件：满{{ couponDetail.condition }}元，减{{ couponDetail.value }}元</view>  */}
                        <div
                          className="use-condition"
                          style={convertLineStyleData(
                            'color:' +
                            (style.strStyle && style.strStyle.color) +
                            ';font-size:' +
                            (style.strStyle && style.strStyle['font-size'])
                          )}
                        >
                          {couponDetail.exchange_condition.price > 0 && (
                            <span>
                              {'¥' + couponDetail.exchange_condition.price}
                            </span>
                          )}
                          {couponDetail.exchange_condition.price > 0 &&
                            couponDetail.exchange_condition.integral > 0 && (
                              <span>+</span>
                            )}
                          {couponDetail.exchange_condition.integral > 0 && (
                            <span>
                              {couponDetail.exchange_condition.integral + '积分'}
                            </span>
                          )}
                        </div>
                      </div>
                      <div
                        className="background-word-area"
                        style={convertLineStyleData('border-color:' + style.secColor)}
                      >
                        <div
                          className="background-circle"
                          style={convertLineStyleData('background-color:' + style.secColor)}
                        ></div>
                        <div className="background-word">减</div>
                      </div>
                    </React.Fragment>
                  ) : couponDetail.type == 1 ? (
                    <React.Fragment>
                      <div className="detail-info">
                        <div className="name">{couponDetail.title}</div>
                        {/*  <view class="use-condition">使用条件: 打{{ couponDetail.value }}折</view>  */}
                        <div
                          className="use-condition"
                          style={convertLineStyleData(
                            'color:' +
                            (style.strStyle && style.strStyle.color) +
                            ';font-size:' +
                            (style.strStyle && style.strStyle['font-size'])
                          )}
                        >
                          {couponDetail.exchange_condition.price > 0 && (
                            <span>
                              {'¥' + couponDetail.exchange_condition.price}
                            </span>
                          )}
                          {couponDetail.exchange_condition.price > 0 &&
                            couponDetail.exchange_condition.integral > 0 && (
                              <span>+</span>
                            )}
                          {couponDetail.exchange_condition.integral > 0 && (
                            <span>
                              {couponDetail.exchange_condition.integral + '积分'}
                            </span>
                          )}
                        </div>
                      </div>
                      <div
                        className="background-word-area"
                        style={convertLineStyleData('border-color:' + style.secColor)}
                      >
                        <div
                          className="background-circle"
                          style={convertLineStyleData('background-color:' + style.secColor)}
                        ></div>
                        <div className="background-word">折</div>
                      </div>
                    </React.Fragment>
                  ) : couponDetail.type == 2 ? (
                    <React.Fragment>
                      <div className="detail-info">
                        <div className="name">{couponDetail.title}</div>
                        {/*  <view class="use-condition">使用条件：可抵扣{{ couponDetail.value }}元</view>  */}
                        <div
                          className="use-condition"
                          style={convertLineStyleData(
                            'color:' +
                            (style.strStyle && style.strStyle.color) +
                            ';font-size:' +
                            (style.strStyle && style.strStyle['font-size'])
                          )}
                        >
                          {couponDetail.exchange_condition.price > 0 && (
                            <span>
                              {'¥' + couponDetail.exchange_condition.price}
                            </span>
                          )}
                          {couponDetail.exchange_condition.price > 0 &&
                            couponDetail.exchange_condition.integral > 0 && (
                              <span>+</span>
                            )}
                          {couponDetail.exchange_condition.integral > 0 && (
                            <span>
                              {couponDetail.exchange_condition.integral + '积分'}
                            </span>
                          )}
                        </div>
                      </div>
                      <div
                        className="background-word-area"
                        style={convertLineStyleData('border-color:' + style.secColor)}
                      >
                        <div
                          className="background-circle"
                          style={convertLineStyleData('background-color:' + style.secColor)}
                        ></div>
                        <div className="background-word">代</div>
                      </div>
                    </React.Fragment>
                  ) : couponDetail.type == 3 ? (
                    <React.Fragment>
                      <div className="detail-info">
                        <div className="name">{couponDetail.title}</div>
                        <div
                          className="use-condition"
                          style={convertLineStyleData(
                            'color:' +
                            (style.strStyle && style.strStyle.color) +
                            ';font-size:' +
                            (style.strStyle && style.strStyle['font-size'])
                          )}
                        >
                          {couponDetail.exchange_condition.price > 0 && (
                            <span>
                              {'¥' + couponDetail.exchange_condition.price}
                            </span>
                          )}
                          {couponDetail.exchange_condition.price > 0 &&
                            couponDetail.exchange_condition.integral > 0 && (
                              <span>+</span>
                            )}
                          {couponDetail.exchange_condition.integral > 0 && (
                            <span>
                              {couponDetail.exchange_condition.integral + '积分'}
                            </span>
                          )}
                        </div>
                        {/*  
                          <view class="use-condition" wx:if="{{ couponDetail.extra_condition == '' }}" >使用条件：直接兑换{{ couponDetail.coupon_goods_info.title }} </view>
                          <view class="use-condition" wx:elif="{{ couponDetail.extra_condition.price }}" >使用条件：消费满{{ couponDetail.extra_condition.price }}元可兑换{{ couponDetail.coupon_goods_info.title }}</view>
                          <view class="use-condition" wx:elif="{{ couponDetail.extra_condition.goods_id }}" >使用条件：购买{{ couponDetail.condition_goods_info.title }}可兑换{{ couponDetail.coupon_goods_info.title }}</view>  
                        */}
                      </div>
                      <div
                        className="background-word-area"
                        style={convertLineStyleData('border-color:' + style.secColor)}
                      >
                        <div
                          className="background-circle"
                          style={convertLineStyleData('background-color:' + style.secColor)}
                        ></div>
                        <div className="background-word">兑</div>
                      </div>
                    </React.Fragment>
                  ) : couponDetail.type == 4 ? (
                    <React.Fragment>
                      <div className="detail-info">
                        <div className="name">{couponDetail.title}</div>
                        <div
                          className="use-condition"
                          style={convertLineStyleData(
                            'color:' +
                            (style.strStyle && style.strStyle.color) +
                            ';font-size:' +
                            (style.strStyle && style.strStyle['font-size'])
                          )}
                        >
                          {couponDetail.exchange_condition.price > 0 && (
                            <span>
                              {'¥' + couponDetail.exchange_condition.price}
                            </span>
                          )}
                          {couponDetail.exchange_condition.price > 0 &&
                            couponDetail.exchange_condition.integral > 0 && (
                              <span>+</span>
                            )}
                          {couponDetail.exchange_condition.integral > 0 && (
                            <span>
                              {couponDetail.exchange_condition.integral + '积分'}
                            </span>
                          )}
                        </div>
                        {/*  <view class="use-condition">使用条件: 储值金可充值{{ couponDetail.value }}元</view>  */}
                      </div>
                      <div
                        className="background-word-area"
                        style={convertLineStyleData('border-color:' + style.secColor)}
                      >
                        <div
                          className="background-circle"
                          style={convertLineStyleData('background-color:' + style.secColor)}
                        ></div>
                        <div className="background-word">储</div>
                      </div>
                    </React.Fragment>
                  ) : couponDetail.type == 5 ? (
                    <React.Fragment>
                      <div className="detail-info">
                        <div className="name">{couponDetail.title}</div>
                        <div
                          className="use-condition"
                          style={convertLineStyleData(
                            'color:' +
                            (style.strStyle && style.strStyle.color) +
                            ';font-size:' +
                            (style.strStyle && style.strStyle['font-size'])
                          )}
                        >
                          {couponDetail.exchange_condition.price > 0 && (
                            <span>
                              {'¥' + couponDetail.exchange_condition.price}
                            </span>
                          )}
                          {couponDetail.exchange_condition.price > 0 &&
                            couponDetail.exchange_condition.integral > 0 && (
                              <span>+</span>
                            )}
                          {couponDetail.exchange_condition.integral > 0 && (
                            <span>
                              {couponDetail.exchange_condition.integral + '积分'}
                            </span>
                          )}
                        </div>
                        {/*  <view class="use-condition">使用条件: {{ couponDetail.extra_condition }}</view>  */}
                      </div>
                      <div
                        className="background-word-area"
                        style={convertLineStyleData('border-color:' + style.secColor)}
                      >
                        <div
                          className="background-circle"
                          style={convertLineStyleData('background-color:' + style.secColor)}
                        ></div>
                        <div className="background-word">通</div>
                      </div>
                    </React.Fragment>
                  ) : (
                                couponDetail.type == 6 && (
                                  <React.Fragment>
                                    <div className="detail-info">
                                      <div className="name">{couponDetail.title}</div>
                                      <div
                                        className="use-condition"
                                        style={convertLineStyleData(
                                          'color:' +
                                          (style.strStyle && style.strStyle.color) +
                                          ';font-size:' +
                                          (style.strStyle && style.strStyle['font-size'])
                                        )}
                                      >
                                        {couponDetail.exchange_condition.price > 0 && (
                                          <span>
                                            {'¥' + couponDetail.exchange_condition.price}
                                          </span>
                                        )}
                                        {couponDetail.exchange_condition.price > 0 &&
                                          couponDetail.exchange_condition.integral > 0 && (
                                            <span>+</span>
                                          )}
                                        {couponDetail.exchange_condition.integral > 0 && (
                                          <span>
                                            {couponDetail.exchange_condition.integral +
                                              '积分'}
                                          </span>
                                        )}
                                      </div>
                                      {/*  <view class="use-condition">使用条件: {{ couponDetail.extra_condition }}</view>  */}
                                    </div>
                                    <div
                                      className="background-word-area"
                                      style={convertLineStyleData('border-color:' + style.secColor)}
                                    >
                                      <div
                                        className="background-circle"
                                        style={convertLineStyleData('background-color:' + style.secColor)}
                                      ></div>
                                      <div className="background-word">次</div>
                                    </div>
                                  </React.Fragment>
                                )
                              )}
                  <div
                    className="bottom-section"
                    style={convertLineStyleData('background-color: ' + style.lineBackgroundColor)}
                  >
                    <div>
                      {'有效期 ' +
                        (couponDetail.expire == '-1'
                          ? couponDetail.start_use_date +
                          '至' +
                          couponDetail.end_use_date
                          : couponDetail.expire == '0'
                            ? '领取当天生效,有效期1天'
                            : '领取' +
                            (couponDetail.react > 0
                              ? couponDetail.react + '天后'
                              : '当天') +
                            '生效，有效期' +
                            couponDetail.expire +
                            '天') +
                        ' ' +
                        (couponDetail.exclude_holiday == 0
                          ? ''
                          : '除去法定节假日') +
                        ' ' +
                        (couponDetail.exclude_weekend == 0 ? '' : '周一至周五') +
                        ' ' +
                        couponDetail.start_use_time +
                        '-' +
                        couponDetail.end_use_time}
                    </div>
                  </div>
                </div>
                <div className="function-btn-wrap">
                  <form>
                    {couponDetail.stock != 0 &&
                      couponDetail.user_recv_num == 0 ? (
                        <button
                          className="function-btn"
                          type="button"
                          onClick={this.formSubmit}
                          data-coupon-id={couponDetail.id}
                          style={convertLineStyleData('background-color:' + style.secColor)}
                        >
                          立即兑换
                      </button>
                      ) : couponDetail.stock == 0 ? (
                        <button className="function-btn disabled">已抢完</button>
                      ) : (
                          couponDetail.stock != 0 &&
                          couponDetail.user_recv_num !== 0 && (
                            <button
                              className="function-btn"
                              type="button"
                              onClick={this.formSubmit}
                              data-coupon-id={couponDetail.id}
                              style={convertLineStyleData('background-color:' + style.secColor)}
                            >
                              再次兑换
                        </button>
                          )
                        )}
                  </form>
                </div>
              </div>
              <div className="middle-section">
                <div className="detail-item condition">
                  <div className="item-name">优惠券类型：</div>
                  <div className="item-content">{couponDetail.stampsType}</div>
                </div>
                <div className="detail-item condition">
                  <div className="item-name">优惠券名称：</div>
                  <div className="item-content">{couponDetail.title}</div>
                </div>
                <div className="detail-item condition">
                  <div className="item-name">可领取用户：</div>
                  <div className="item-content">{couponDetail.stampsUser}</div>
                </div>
                <div className="detail-item time">
                  <div className="item-name">可用时间：</div>
                  <div
                    className="item-content"
                    style={convertLineStyleData('position:relative;top:-5rpx')}
                  >
                    <div className="date-duration">
                      {couponDetail.expire == '-1'
                        ? couponDetail.start_use_date +
                        '至' +
                        couponDetail.end_use_date
                        : couponDetail.expire == '0'
                          ? '领取当天生效,有效期1天'
                          : '领取' +
                          (couponDetail.react > 0
                            ? couponDetail.react + '天后'
                            : '当天') +
                          '生效，有效期' +
                          couponDetail.expire +
                          '天'}
                    </div>
                    <div className="other-case">
                      {(couponDetail.exclude_holiday == 1 ? '除法定节假日' : '') +
                        ' ' +
                        (couponDetail.exclude_weekend == 1 ? '周一至周五' : '')}
                    </div>
                    <div className="time-duration">
                      {couponDetail.start_use_time +
                        '-' +
                        couponDetail.end_use_time}
                    </div>
                  </div>
                </div>
                {couponDetail.type == 6 && (
                  <div className="detail-item condition">
                    <div className="item-name">可兑换次数：</div>
                    <div className="item-content">
                      {couponDetail.useCondition}
                    </div>
                  </div>
                )}
                {couponDetail.type != 6 && (
                  <div className="detail-item condition">
                    <div className="item-name">优惠方式：</div>
                    <div className="item-content">
                      {couponDetail.useCondition}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              className={'zc-toast-bg ' + (receiveSuccess == 1 ? 'show' : '')}
              onClick={this.hideReceiveToast}
            >
              <div className="zc-toast receive-success">
                <Icon className="icon" type="success" size="xss"></Icon>
                <div className="title">兑换成功!</div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/exchange-coupon-detail/ExchangeCouponDetail.jsx